import React, { CSSProperties, FC } from 'react'
import styled from 'styled-components'

type Props = Pick<
  CSSProperties,
  | 'width'
  | 'height'
  | 'marginLeft'
  | 'marginRight'
  | 'marginTop'
  | 'marginBottom'
  | 'order'
  | 'display'
>

export const Spacer: FC<Props> = props => {
  return <StyledDiv css={props} />
}

// Need to enforce a `styled` import for `css` prop to work!
const StyledDiv = styled.div``
